import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'
import { v4 as uuidv4 } from 'uuid'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    boards: [],
    deletedBoards: [],
    deletedPins: [],
  },
  mutations: {
    setBoards(state, payload) {
      state.boards = payload
    },
    insertBoard(state, payload) {
      const board = {
        boardID: uuidv4(),
        data: {
          boardName: payload.boardName,
          boardDescription: payload.boardDescription,
        },
        pins: [],
        change: 'create',
      }
      state.boards.push(board)
      console.log(board)
      console.log(state.boards)
    },
    updateBoard(state, payload) {
      console.log('updateBoard')
      console.log(payload)
      const index = state.boards.findIndex(x => x.boardID === payload.boardID)
      console.log(index)
      if (index > -1) {
        state.boards[index] = payload
        Vue.set(state.boards, index, payload)
      }
      console.log(state.boards)
    },
    removeBoard(state, payload) {
      const index = state.boards.indexOf(payload.board)
      console.log(index)
      if (index > -1) {
        state.boards.splice(index, 1)
      }
      state.deletedBoards.push(payload.board)
      console.log(state.deletedBoards)
    },
    insertPin(state, payload) {
      console.log(payload)
      const pin = {
        pinID: uuidv4(),
        change: 'create',
        data: {
          channelName: payload.pin.first.snippet.channelTitle,
          channelid: payload.pin.first.snippet.channelId,
          title: payload.pin.first.snippet.title,
          videoId: payload.pin.first.id,
          youtubeURL: payload.pin.youtubeURL,
        },
      }
      payload.pin.pinID = uuidv4()
      const boardRef = state.boards.indexOf(payload.board)
      state.boards[boardRef].pins.push(pin)
      state.boards[boardRef].pinChange = true
      console.log(state.boards)
      Vue.set(state.boards, boardRef, state.boards[boardRef])
    },
    updatePin(state, payload) {
      console.log('updatePin')
      payload.pin.change = 'update'
      console.log(payload)
      const boardRef = state.boards.indexOf(payload.board)
      console.log(boardRef)
      const pinRef = state.boards[boardRef].pins.indexOf(payload.pin)
      console.log(pinRef)
      if (pinRef > -1) {
        state.boards[boardRef].pins[pinRef].data.notes = payload.updatedPin.data.notes
        payload.board.pinChange = true
        Vue.set(state.boards, boardRef, payload.board)
        console.log(state.boards)
      }
    },
    removePin(state, payload) {
      console.log('removePin')
      const boardRef = state.boards.indexOf(payload.board)
      const pinRef = state.boards[boardRef].pins.indexOf(payload.pin)
      if (pinRef > -1) {
        payload.board.pins.splice(pinRef, 1)
        payload.pin.boardID = payload.board.boardID
        state.deletedPins.push(payload.pin)
        Vue.set(state.boards, boardRef, payload.board)
      }
      // const pillarRef = state.pillars.indexOf(payload.pillar)
      // const keywordRef = state.pillars[pillarRef].keywords.indexOf(payload.keyword)
      // if (keywordRef > -1) {
      //   payload.pillar.keywords.splice(keywordRef, 1)
      //   payload.keyword.pillarID = payload.pillar.pillarID
      //   state.deletedKeywords.push(payload.keyword)
      //   Vue.set(state.pillars, pillarRef, payload.pillar)
      // }
    },
  },
  actions: {
    // read boards when app loads
    getBoards(context) {
      const payload = []
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              boardID: doc.id,
              data: doc.data(),
            }
            payload.push(data)
          })
          return context.dispatch('connectPins', payload)
        })
    },
    connectPins(context, boards) {
      boards.forEach(board => {
        context.dispatch('getPins', board)
      })
      context.commit('setBoards', boards)
    },
    getPins(context, board) {
      const pins = []
      firebaseDatabase.collection('creators')
        .doc(firebaseAuth.currentUser.uid)
        .collection('boards')
        .doc(board.boardID)
        .collection('pins')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              pinID: doc.id,
              data: doc.data(),
            }
            pins.push(data)
          })
          board.pins = pins
          return board
        })
    },
  },
  getters: {
    state: state => state,
  },
}
